// extracted by mini-css-extract-plugin
export default {"ascSelected":"_31hD","descSelected":"_15yh","icons":"_2UM8"};